import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const BloodIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M13 15a1 1 0 100 2 1 1 0 000-2zM10 17a1 1 0 100 2 1 1 0 000-2z"
        fill="#001533"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.493 3.25H8.5a.75.75 0 100 1.5h.26v5.087a7.25 7.25 0 01-1.255 4.078L4.41 18.463a1.855 1.855 0 001.327 2.887c4.162.468 8.363.468 12.525 0a1.855 1.855 0 001.327-2.887l-3.094-4.548a7.25 7.25 0 01-1.256-4.078V4.75h.26a.75.75 0 000-1.5h-1.007zM5.905 19.86c4.05.455 8.14.455 12.19 0a.355.355 0 00.254-.553l-3.093-4.549a8.744 8.744 0 01-.592-1.008H9.336a8.744 8.744 0 01-.591 1.008L5.65 19.307a.355.355 0 00.254.553zm4.016-7.61h4.159a8.748 8.748 0 01-.34-2.413V4.75h-3.48v5.087c0 .82-.115 1.633-.34 2.413z"
        fill="#001533"
      />
    </Svg>
  );
};

export default BloodIcon;
